import { useEffect, useState } from 'react';
import { useEffectAsync } from '../../../helpers';
import apiClient from '../../../Services/ApiClient';
import useApiClient from '../../Base/Hooks/useApiClient';
import { CaseTypeType } from '../Enums/CaseTypeType.enum';

export interface CaseTypeTreeItem {
	id: string;
	children?: CaseTypeTreeItem[];
	caseType: {
		id: string;
		label: string;
		type: CaseTypeType;
	};
	parentId?: string;
}

export default function useCaseTypeTree(
	workplaceId: string,
	healthPlanCode?: string,
) {
	const [caseTypeTree, setCaseTypeTree] = useState<CaseTypeTreeItem[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isOnlyOneRoot, setIsOnlyOneRoot] = useState(false);

	const { displayError } = useApiClient();

	const handleLoadCaseTypeTree = async () => {
		setIsLoading(true);
		let endpoint = `/workplaces/${workplaceId}/case/type/tree`;

		if (healthPlanCode) {
			endpoint = `/workplaces/${workplaceId}/case/type/module/${healthPlanCode}/tree`;
		}

		try {
			const response = await apiClient.get(endpoint);
			if (response) {
				setCaseTypeTree(response.data as CaseTypeTreeItem[]);
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await handleLoadCaseTypeTree();
	}, []);

	useEffect(() => {
		setIsOnlyOneRoot(caseTypeTree.length < 2);
	}, [caseTypeTree]);

	return {
		caseTypeTree,
		isOnlyOneRoot,
		reFetch: handleLoadCaseTypeTree,
		isLoading,
	};
}
